import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DrawerTypes } from '@dtx-company/inter-app/src/redux/slices/drawer'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { theme } from '@dtx-company/shared-components/src'
import { useDrawer } from '@dtx-company/inter-app/src/redux/slices/utils/drawer'
import styled from 'styled-components'

interface GettingStartedButtonProps {
  drawerType: DrawerTypes
  callback?: () => void
  isHighlighted?: boolean
  shortText?: boolean
}

const StyledBox = styled(Box)<{ isHighlighted?: boolean }>`
  ${props =>
    props.isHighlighted &&
    `

border: ${theme.colors.secondary.backgroundLight};
background-color: ${theme.colors.secondary.backgroundLight};
box-shadow: 0px 0px 3px 2px ${theme.colors.secondary.backgroundLight};

-webkit-animation: flicker 0.5s ease-in-out 4s forwards;
animation: flicker 0.5s ease-in-out 4s forwards;

@-webkit-keyframes flicker {
  0%,
  20%,
  50%,
  80%,
  100% {
    z-index: 1001;
  }
  40% {
    z-index: 10;
  }
  60% {
    x-index: 1001;
  }
}

@keyframes flicker {
  0%,
  20%,
  50%,
  80%,
  100% {
    z-index: 1001;
  }
  40% {
    z-index: 10;
  }
  60% {
    x-index: 1001;
  }
}

`}
`

export const FAQButton = ({
  drawerType,
  callback,
  isHighlighted,
  shortText
}: GettingStartedButtonProps): JSX.Element => {
  const { setOpen } = useDrawer(drawerType)

  return (
    <StyledBox
      tabIndex={0}
      borderRadius="12px"
      cursor="pointer"
      px="12px"
      py={1}
      isHighlighted={isHighlighted}
      style={{ whiteSpace: 'nowrap' }}
      onClick={() => {
        callback?.()
        setOpen()
      }}
      onKeyDown={e => {
        if (e.key == 'Enter') {
          callback?.()
          setOpen()
        }
      }}
    >
      <Icon my="auto" mr={'8px'} src="/icons/education-outline.svg" style={{ minWidth: '24px' }} />
      <Text my="auto" variant={'button/general'} color={theme.colors.primary.flowBlue}>
        {shortText ? 'FAQ' : 'Reports FAQ'}
      </Text>
    </StyledBox>
  )
}
